import React from 'react';

import { IIconProps } from '@icons/interface';

function KaiAssistantIcon(props: IIconProps) {
	const { isActive } = props;

	return (
		<svg
			fill='none'
			height='28'
			viewBox='0 0 28 28'
			width='28'
			{...props?.innerSvgProps}
		>
			<path
				d='M16.7162 6H13.321L5 21H8.23465C8.25432 20.9672 8.27398 20.9345 8.29364 20.8984C10.3944 17.0771 12.5147 13.269 14.6319 9.45423L14.9727 8.84138C15.4381 9.87699 15.8346 10.7979 16.2705 11.6959C16.4475 12.0596 16.454 12.3415 16.2377 12.6922C15.8084 13.3935 15.4315 14.1243 14.9924 14.9174C15.8051 14.9174 16.5196 14.9338 17.234 14.9141C17.5289 14.9043 17.6928 14.9961 17.7977 15.2779C17.9878 15.7826 18.2204 16.2709 18.4367 16.7691C18.6104 17.1656 18.7907 17.5622 18.9906 18.0177C18.0205 18.0079 17.1685 18.0013 16.2574 17.9915C16.6965 19.0435 17.0996 20.0267 17.5257 20.9967H23.3133L16.7162 6Z'
				fill={isActive ? '#2E2E6B' : '#4D4DB3'}
			/>
			<path
				d='M14.1893 21C13.819 20.125 13.4716 19.2958 13.0947 18.4077L11.656 21H14.1893Z'
				fill={isActive ? '#2E2E6B' : '#4D4DB3'}
			/>
			<path
				d='M21.0491 15.7989C20.9147 15.4646 20.7607 15.1533 20.6034 14.842L21.249 16.3069C21.1802 16.1398 21.1146 15.9693 21.0491 15.7989Z'
				fill={isActive ? '#2E2E6B' : '#4D4DB3'}
			/>
			<path
				d='M18.4498 9.99165C18.6399 10.4144 18.8332 10.8306 19.0201 11.2436L18.0172 8.96259C18.1614 9.30343 18.3023 9.64754 18.4498 9.99165Z'
				fill={isActive ? '#2E2E6B' : '#4D4DB3'}
			/>
			<path
				d='M16.7158 6L18.0202 8.96264C17.604 7.96308 17.191 6.97007 16.7289 6H16.7158Z'
				fill={isActive ? '#2E2E6B' : '#4D4DB3'}
			/>
			<path
				d='M19.0204 11.2435L19.961 13.3868C19.666 12.6625 19.3481 11.9579 19.0204 11.2435Z'
				fill={isActive ? '#2E2E6B' : '#4D4DB3'}
			/>
			<path
				d='M20.6029 14.842L19.9606 13.3836C20.0359 13.5671 20.108 13.7474 20.1801 13.9342C20.3112 14.252 20.4554 14.547 20.6029 14.842Z'
				fill={isActive ? '#2E2E6B' : '#4D4DB3'}
			/>
			<path
				d='M21.8517 17.6768L22.9725 20.2266C22.6382 19.3483 22.2384 18.5158 21.8517 17.6768Z'
				fill={isActive ? '#2E2E6B' : '#4D4DB3'}
			/>
			<path
				d='M21.2488 16.307C21.4389 16.7691 21.6421 17.2246 21.8518 17.6769L21.2488 16.307Z'
				fill={isActive ? '#2E2E6B' : '#4D4DB3'}
			/>
			<mask
				height='4'
				id='mask0_19117_70647'
				maskUnits='userSpaceOnUse'
				style={{ maskType: 'luminance' }}
				width='4'
				x='18'
				y='6'
			>
				<path
					d='M20.1107 6C19.1997 6 18.4623 6.73738 18.4623 7.64846C18.4623 8.55954 19.1997 9.29692 20.1107 9.29692C21.0218 9.29692 21.7592 8.55954 21.7592 7.64846C21.7592 6.73738 21.0218 6 20.1107 6Z'
					fill='white'
				/>
			</mask>
			<g
				mask='url(#mask0_19117_70647)'>
				<path
					d='M18.4657 6H21.7593V9.29364H18.4657V6Z'
					fill='#4D4DB3'
				/>
			</g>
		</svg>

	);
}

export default KaiAssistantIcon;
